export function makePairs (from, opts) {
  const keys = opts.keys || Object.keys(from)
  let pairs = []

  for (const i of new Array(Math.floor(keys.length / 2)).keys()) {
    const pair = [
      from[keys[2 * i]],
      from[keys[2 * i + 1]]
    ]
    pairs.push(pair)
  }

  if (opts.fill && keys.length % 2) {
    pairs.push([
      from[keys[keys.length - 1]]
    ])
  }

  return pairs
}
